import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, filter, mergeMap } from 'rxjs/operators';
import {
  STORE_CHANNEL_EDIT_MODE,
  STORE_CHANNEL_FIND,
  STORE_CHANNEL_FIND_ALL,
  STORE_CHANNEL_FIND_ALL_SUCCESS,
  STORE_CHANNEL_FIND_SUCCESS,
  STORE_CHANNEL_UPDATE_LOADING,
  SERVICE_FAILURE,
} from '@store/actions';
import { LocalCanal } from '@core/models';
import { StoreChannelService } from '@core/services';

@Injectable()
export class StoreChannelEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private storeChannelService: StoreChannelService
  ) {}

  findLocalChannel$ = createEffect(() =>
    this.actions$.pipe(
      ofType(STORE_CHANNEL_FIND),
      filter((action) => action.id !== null),
      mergeMap(({ id }) => {
        this.store.dispatch(STORE_CHANNEL_UPDATE_LOADING({  loading: true }));

        return this.storeChannelService.find(id).pipe(
          mergeMap(({ data }) => {
            const [storeChannel] = data as LocalCanal[];

            return [
              STORE_CHANNEL_EDIT_MODE({ editMode: true }),
              STORE_CHANNEL_UPDATE_LOADING({ loading: false }),
              STORE_CHANNEL_FIND_SUCCESS({ storeChannel }),
            ];
          }),
          catchError((error) => 
            of(error).pipe(
              mergeMap((error) => {
                return [
                  SERVICE_FAILURE({ error }),
                  STORE_CHANNEL_UPDATE_LOADING({ loading: false }),
                ];
              })
            )
          )
        )
      }),
    )
  );

  findCategories$ = createEffect(() =>
    this.actions$.pipe(
      ofType(STORE_CHANNEL_FIND_ALL),
      mergeMap(({ seccion }) => {
        this.store.dispatch(STORE_CHANNEL_UPDATE_LOADING({  loading: true }));

        return this.storeChannelService.findAll(seccion).pipe(
          mergeMap(({ data }) => {
            const storeChannelList = data as LocalCanal[];

            return [
              STORE_CHANNEL_FIND_ALL_SUCCESS({ storeChannelList }),
              STORE_CHANNEL_UPDATE_LOADING({ loading: false }),
            ];
          }),
          catchError((error) => 
            of(error).pipe(
              mergeMap((error) => {
                return [
                  SERVICE_FAILURE({ error }),
                  STORE_CHANNEL_UPDATE_LOADING({ loading: false }),
                ];
              })
            )
          )
        )
      }),
    )
  );
}
